import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    num: "01",
    title: "Meta Ads",
    desc: "Full-funnel campaign structure, audience architecture and high-velocity testing. Media buying built to scale what performs.",
  },
  {
    num: "02",
    title: "Creative Strategy",
    desc: "Data-informed hooks, angles and scripts. We find the message before we spend the money.",
  },
  {
    num: "03",
    title: "AI Content Studio",
    desc: "AI-powered UGC, avatars, product videos and creative variations — produced at the speed of testing.",
  },
];

export default function WhatWeDo() {
  return (
    <section id="what-we-do" data-testid="section-what-we-do" className="px-6 py-28 sm:px-10 sm:py-36 lg:px-14">
      <div className="mb-16 flex items-end justify-between">
        <p className="font-monoalt text-[13px] font-light uppercase tracking-[0.18em] text-zinc-500">
          / What We Do
        </p>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="hidden font-monoalt text-[11px] uppercase tracking-[0.35em] text-zinc-500 sm:block">
            Performance × Creative
          </p>
        </motion.div>
      </div>

      <div className="border-t border-[#27272A]">
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.num}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`service-row-${s.num}`}
            className="group grid grid-cols-12 items-baseline gap-4 border-b border-[#27272A] py-10 transition-colors duration-500 hover:bg-[#F4F4F5] sm:py-12 lg:px-6"
          >
            <span className="col-span-2 font-monoalt text-xs text-zinc-500 transition-colors duration-500 group-hover:text-zinc-600 sm:col-span-1">
              ({s.num})
            </span>
            <h3 className="col-span-10 font-display text-3xl font-bold uppercase leading-none tracking-tight transition-colors duration-500 group-hover:text-black sm:col-span-5 sm:text-5xl">
              {s.title}
            </h3>
            <p className="col-span-10 col-start-3 max-w-md text-sm leading-relaxed text-zinc-400 transition-colors duration-500 group-hover:text-zinc-700 sm:col-span-5 sm:col-start-7">
              {s.desc}
            </p>
            <ArrowUpRight className="hidden h-6 w-6 justify-self-end text-black opacity-0 transition-opacity duration-500 group-hover:opacity-100 lg:block" />
          </motion.div>
        ))}
      </div>
    </section>
  );
}
